// import router from 'vue-router'
import Vue from 'vue'


const actions = {
  // saveCurrentUnload: ({getters}, payload) => {
  //   let currentUnload = {
  //     ...getters.getCurrentUnloading,
  //     locationId: parseInt(payload.location),
  //     palletPlaces:payload.palletPlaceValue,
  //     end_time: new Date()
  //   }
  //   return Vue.prototype.$FB
  //       .collection('incoming-products')
  //       .add(currentUnload)
  // },
  checkIfBarcodeIsLocation: ({rootGetters}, payload) => {
    return rootGetters['locations/getLocation'](payload)
  },
  finishCargoByDockId: ({state, commit, rootGetters, dispatch}, payload) => {
    dispatch('cargo/patch', { finished: true, id: payload.id, finishedAt: new Date(), finishedBy: payload.finishedBy}, {root: true}).then(() => {
      return Vue.prototype.$FB.collection('cargos').doc(payload.id).update({
        finishedBy: payload.finishedBy,
        finishedAt:new Date(),
        finished: true
      });
    })
  }
}

export default actions

